<template>
    <nav class="tab-list_container">
        <ul class="tab-list_container_list">
            <TabListItem v-for="tab of tabs" :key="tab.name" :tab="tab" />
        </ul>
    </nav>
</template>

<script setup lang="ts">
    import type {PropType} from 'vue';
    import type {TabItem} from '@common/types';
    import TabListItem from './TabListItem.vue';

    defineProps({
        tabs: {type: Array as PropType<TabItem[]>, required: true},
    });
</script>

<style lang="scss" scoped>
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/text';

    .tab-list_container {
        flex: 0 0 auto;
        width: 100%;
        display: flex;
        background-color: var(--joy-color-neutral-0);
        border: 1px solid var(--joy-color-neutral-30);
        border-radius: var(--joy-core-radius-3);
        position: sticky;
        top: calc(var(--header-height) + 24px);
        align-self: start;
        z-index: 1;

        &_list {
            width: 100%;
            list-style-type: none;
            padding: 0;
            display: flex;
            flex-flow: column wrap;
            margin: 0;
        }
    }
</style>
